export function searchProposalLayoutEffect({ document, vueInstance }) {
  const body = document.getElementsByTagName('body')[0];

  function addBackgroundColor() {
    body.style.backgroundColor = "white";
  }
  function removeBackgroundColor() {
    body.removeAttribute('style');
  }

  function filtersFixed() {
    setTimeout(() => {
      vueInstance.$nextTick(() => {
        const filters_fixed_nav = document.getElementsByClassName('filters-fixed-nav');
        if (filters_fixed_nav.length > 0) filters_fixed_nav[0].style.display = 'block';
      });
    }, 500);
  }

  return {
    addBackgroundColor,
    removeBackgroundColor,
    filtersFixed,
  };
}